export default function filterHelper(region, filter) {
  const add = obj => Object.values(obj).reduce((a, b) => a + b, 0);

  switch (filter) {
    case 'US':
      return {
        total_organic_search_traffic: region.total_organic_search_traffic.us,
        total_organic_search_traffic_value: region.total_organic_search_traffic_value.us,
        total_content_debit: region.total_content_debit,
        average_cpc: region.average_cpc.us
      };
    case 'Canada':
      return {
        total_organic_search_traffic: region.total_organic_search_traffic.canada,
        total_organic_search_traffic_value: region.total_organic_search_traffic_value.canada,
        total_content_debit: region.total_content_debit,
        average_cpc: region.average_cpc.canada
      };
    case 'All':
    default:
      return {
        total_organic_search_traffic: add(region.total_organic_search_traffic),
        total_organic_search_traffic_value: add(region.total_organic_search_traffic_value),
        total_content_debit: region.total_content_debit,
        average_cpc: add(region.average_cpc)
      };
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/filterHelper.js